import { useSyncExternalStore, type ReactNode, type MouseEvent } from 'react'
import { DEMO } from './config'

/** Router mínimo: rutas con historial en producción (Cloudflare), con #hash en la vista previa. */
const listeners = new Set<() => void>()
const read = () => (DEMO ? window.location.hash.replace(/^#/, '') || '/' : window.location.pathname + window.location.search)
let current = read()
window.addEventListener(DEMO ? 'hashchange' : 'popstate', () => { current = read(); listeners.forEach(l => l()) })

export function navigate(to: string) {
  if (to === current) return
  if (DEMO) window.location.hash = to
  else { history.pushState(null, '', to); current = read(); listeners.forEach(l => l()) }
  window.scrollTo({ top: 0 })
}

export function useLocation() {
  const loc = useSyncExternalStore(cb => { listeners.add(cb); return () => listeners.delete(cb) }, () => current)
  const [path, qs = ''] = loc.split('?')
  return { path, query: new URLSearchParams(qs) }
}

export function Link({ to, children, className, onClick }: { to: string; children: ReactNode; className?: string; onClick?: () => void }) {
  const href = DEMO ? `#${to}` : to
  return (
    <a href={href} className={className} onClick={(e: MouseEvent) => {
      if (e.metaKey || e.ctrlKey) return
      e.preventDefault(); onClick?.(); navigate(to)
    }}>{children}</a>
  )
}
